import { BlokProps } from '@/lib/types'
import { SimpleTextStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { Container } from '../shared/container'
import { RichText } from '../shared/rich-text'

export function SimpleText({ blok }: BlokProps<SimpleTextStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border border-y py-20"
    >
      <Container>
        <RichText content={blok.content} />
      </Container>
    </section>
  )
}
